export default (settings: any) => settings['joinEntities'] * (1 / 60) * 31
